import {Component, Input, NgZone, OnInit} from '@angular/core';
import {InteractionDto} from 'src/app/modules/conference/models/card.model';
import {ConferenceService} from 'src/app/modules/conference/service/conference.service';
import {NapiService} from '../../../../services/napi.service';

interface ChangeIsResultsDto {
  isResults: boolean;
}

@Component({
  selector: 'app-journey-list-template-interaction-embedded',
  templateUrl: './list-template-interaction-embedded.component.html',
  styleUrls: ['./list-template-interaction-embedded.component.scss']
})
export class LearningJourneyListTemplateInteractionEmbeddedComponent implements OnInit {
  constructor(
    private conferenceService: ConferenceService,
    private ngZone: NgZone,
    private napiService: NapiService,
  ) {
  }

  @Input() interactionId: any;

  interaction: InteractionDto | null = null;
  isInteractionActive: boolean = false;
  isResultsActive: boolean = false;
  isWordCloudReady: boolean = false;

  socket = null;

  ngOnInit(): void {
    this.initInteraction(this.interactionId);
    this.initWebSocket(this.interactionId);
  }

  protected initInteraction(interactionId: string) {
    this.conferenceService.getActiveCards(interactionId).then(interaction => {
      if (interaction) {
        this.interaction = interaction;

        if (interaction.interactionsGroups
          && interaction.interactionsGroups.length > 0
          && interaction.interactionsGroups[0].interactionsCards
          && interaction.interactionsGroups[0].interactionsCards.length > 0
        ) {
          this.isInteractionActive = true;
          this.isResultsActive = interaction.interactionsGroups[0].isResults;
          this.isWordCloudReady = this.isResultsActive;

          console.log('this.isResultsActive', this.isResultsActive);
        } else {
          this.isInteractionActive = false;
          this.isResultsActive = false;
          this.isWordCloudReady = false;
        }
      } else {
        this.clearInteraction();
      }
    }).catch(() => {
      this.clearInteraction();
    });
  }

  protected clearInteraction() {
    this.interaction = null;
    this.isInteractionActive = false;
    this.isResultsActive = false;
    this.isWordCloudReady = false;
  }

  protected changeIsResult(payload: ChangeIsResultsDto) {
    this.isWordCloudReady = false;
    this.isResultsActive = payload.isResults;
  }

  protected initWebSocket(interactionId: string) {
    this.socket = this.napiService.socket('interactions');

    this.socket.on('connect', () => {
      console.log('Connected to WebSocket server');
      this.socket.emit('joinRoom', interactionId); // Join to room 'Interaction ID'
    });

    this.socket.on('disconnect', function() {
      console.log('Disconnect client event...');
    });

    this.socket.on('message', data => {
      this.handleInteractionMessage(data);
    });
  }

  protected handleInteractionMessage(payload) {
    console.log('Received message:', payload); // 'setActive', 'setInactive'
    this.ngZone.run(() => {
      switch (payload.message) {
        case 'setActive':
          this.initInteraction(payload.interactionId);
          break;
        case 'setInactive':
          this.initInteraction(payload.interactionId);
          break;
        case 'WordCloudStart':
          this.isWordCloudReady = false;
          break;
        case 'WordCloudComplete':
          this.isWordCloudReady = true;
          break;
        case 'changeIsResults':
          this.changeIsResult(payload.data);
          break;
      }
    });
  }

}
